import { create } from "zustand";
import { QueuesActions, QueuesState } from "./types";
import { Queue } from "@/repository/models";

export const useQueuesStore = create<QueuesState & QueuesActions>((set) => ({
	queues: [],
	isDataLoaded: false,
	isJoinedOnAnyQueue: false,
	pendingQueueIds: new Set<string>(),
	setIsDataLoaded: (isDataLoaded: boolean) =>
		set({ isDataLoaded: isDataLoaded }),
	setQueues: (queues: Queue[]) =>
		set((state: QueuesState) => {
			const merged = queues.map((q) =>
				state.pendingQueueIds.has(q.id)
					? (state.queues.find((x) => x.id === q.id) ?? q)
					: q
			);
			return {
				queues: merged,
				isJoinedOnAnyQueue: merged.some((x) => x.isAttached),
			};
		}),
	remove: (id: string) =>
		set((state: QueuesState) => {
			const updated = state.queues.filter((x) => x.id !== id);

			return {
				queues: updated,
				isJoinedToAnyQueue: updated.some((x) => x.isAttached),
			};
		}),
	update: (queue: Queue) =>
		set((state: QueuesState) => {
			const queues = state.queues;
			const id = queue.id;

			const updated = queues.some((x: Queue) => x.id === id)
				? queues.map((q: Queue) =>
						q.id === id ? { ...q, ...queue, type: q.type } : q
					)
				: [...queues, queue];

			return {
				queues: updated,
				isJoinedOnAnyQueue: updated.some((x) => x.isAttached),
			};
		}),
	setPending: (id: string) =>
		set((state: QueuesState) => ({
			pendingQueueIds: new Set(state.pendingQueueIds).add(id),
		})),
	clearPending: (id: string) =>
		set((state: QueuesState) => {
			const next = new Set(state.pendingQueueIds);
			next.delete(id);
			return { pendingQueueIds: next };
		}),
}));
